// @ts-nocheck
export const imageFormats = ['png', 'jpeg', 'jpg', 'svg'];
